/** @format */

import {gql} from '@apollo/client';

export const UPDATE_DIGITAL_CAST_SETTINGS = gql`
  mutation UpdateDigitalCastSettings($settings: AccountsDigitalCastSettingsInput!) {
    updateDigitalCastSettings(settings_input: $settings)
  }
`;

export const VOTE_FOR_STUB_LAYER = gql`
  mutation VoteForStubLayer($layerId: StubLayerId!) {
    voteForStubLayer(layerId: $layerId) {
      success
      totalVotes
      hasVoted
    }
  }
`;
